module.exports = __webpack_public_path__ + "img/bar-chart-square-minus.cef9ca5d.svg";